import React, { forwardRef, useImperativeHandle, useState } from "react";
import clsx from "clsx";
import { Box, Button, Form, Stack, Typography } from "@curves/ui-base";
import { Grid } from "@mui/material";
import SendSmsDialog from "@icoach/components/dialog/SendSmsDialog";
import useToggleDialog from "@util/hook/useToggleDialog";
import { isEqual } from "@util/utils";
import { PEOPLE_TYPE } from "@icoach/constants";

const SMS_DIALOG = "smsDialog";

/** ================================
 * 📌 批次發送簡訊
 *  ================================
 */
const BatchSmsSendAction = forwardRef((props, ref) => {
	const {
		onHideAction,
		getCheckedSourceData,
		className
	} = props;
	const { openTarget, handleOpenDialog, handleCloseDialog, sourceData } = useToggleDialog();
	const [selectionStats, setSelectionStats] = useState({
		count: 0
	});


	const handleSubmit = () => {
		const params = getCheckedSourceData().map(({ memberID, memberName, nickName }) => ({
			type: PEOPLE_TYPE.MEMBER,
			id: memberID,
			name: nickName || memberName,
		}));

		if (params.length > 0) handleOpenDialog(SMS_DIALOG, { sourceData: params });
	};

	useImperativeHandle(ref, () => ({
			setSelectionStats: (params) => setSelectionStats(params)
		}),
		// eslint-disable-next-line
		[]);

	return (
		<>
			<Box className={clsx("mb-2 batch-controller-panel", className)}>
				<Form onSubmit={handleSubmit}>
					<Grid className={className} spacing={2} container>
						<Grid xs={7} item>
							<Typography className={"font-weight-bold"} variant={"body1"}>
								請選擇要發送簡訊的名單
							</Typography>
							<Typography variant={"body1"}>
								選取筆數：<strong className={"h6 text-primary"}>{selectionStats.count}</strong>
							</Typography>
						</Grid>
						<Grid xs={5} item>
							<Stack className={"h-100"} direction={"column"} justifyContent={"end"}>
								<Box className={"btn-group"}>
									<Button color={"grey"} variant={"outlined"} onClick={onHideAction}>
										取消
									</Button>
									<Button type={"submit"} variant={"outlined"}>
										進行簡訊編輯
									</Button>
								</Box>
							</Stack>
						</Grid>
					</Grid>
				</Form>
			</Box>
			<SendSmsDialog open={isEqual(openTarget, SMS_DIALOG)} onClose={handleCloseDialog} sourceData={sourceData}
						   refresh={onHideAction} />
		</>

	);
});

export default BatchSmsSendAction;
